import { FLAGS, type FlagName } from "./manifest";

/**
 * Read a flag's effective boolean value.
 *
 * Resolution order:
 *   1. `process.env.FLAG_<NAME>` — server-side override
 *   2. `process.env.NEXT_PUBLIC_FLAG_<NAME>` — client-shipped override (build-time inlined)
 *   3. manifest default
 *
 * Override values are case-insensitive: `true|1` → true, `false|0` → false.
 * Anything else is ignored and falls through to the next resolution step.
 */
export function isFlagOn(name: FlagName): boolean {
  const def = FLAGS[name];
  const serverEnv = process.env[`FLAG_${name}`];
  const publicEnv = process.env[`NEXT_PUBLIC_FLAG_${name}`];
  const override = parseFlagOverride(serverEnv) ?? parseFlagOverride(publicEnv);
  return override ?? def.default;
}

function parseFlagOverride(value: string | undefined): boolean | undefined {
  if (value == null) return undefined;
  const v = value.trim().toLowerCase();
  if (v === "true" || v === "1") return true;
  if (v === "false" || v === "0") return false;
  return undefined;
}
